import React from 'react';

import { Grid } from '@gogame/components';
import { withForm, SidePageV2, FormField, FormFieldArray } from '@gogame/form';
import { dateFNS } from '@gogame/intl-ts';

import { CAMPAIGN_NAME } from 'scenes/Campaigns/components/Form/Campaign/constants';
import { multiCampaignsSchema } from 'scenes/Campaigns/GGCampaigns/components/CampaignForm/schema';
import { loadAffiliates } from 'scenes/Campaigns/sources/fields';

import {
  CAMPAIGNS,
  AFFILIATE,
  TEST_CAMPAIGN_END_DATE,
} from 'scenes/Campaigns/components/Form/constants';

const validateStartDate = (startDate) => {
  if (!startDate) {
    return 'Start Date is required';
  }
};

const MoveToAnotherAffiliateForm = withForm({
  enableReinitialize: true,
  validationSchema: multiCampaignsSchema,
})(({ open, name, loading, fetching, onClose, onExited }) => {
  return (
    <SidePageV2
      onClose={onClose}
      onExited={onExited}
      open={open}
      loading={loading}
      fetching={fetching}
      size={'lg'}
    >
      <SidePageV2.Title
        title={'Move campaign to another affiliate'}
        subTitle={name}
      />
      <SidePageV2.NewBody>
        <Grid container spacing={3} direction={'column'}>
          <Grid item>
            <FormFieldArray>
              {() => (
                <FormField.TextField
                  name={`${CAMPAIGNS}[0].${CAMPAIGN_NAME}`}
                  padding={0}
                  label={'New campaign name'}
                  required={true}
                />
              )}
            </FormFieldArray>
          </Grid>
          <Grid item>
            <FormField.Select
              name={AFFILIATE}
              label={'Target affiliate'}
              source={loadAffiliates}
              padding={'0'}
              required={true}
              withDeselectButton={true}
            />
          </Grid>
          <Grid item>
            <FormField.DatePicker
              required
              name={TEST_CAMPAIGN_END_DATE}
              label={'Start date'}
              padding={0}
              minDate={dateFNS.addDays(new Date(Date.now()), 1)}
              placeholder={false}
              validate={validateStartDate}
            />
          </Grid>
        </Grid>
      </SidePageV2.NewBody>
      <SidePageV2.Actions>
        <SidePageV2.CloseButton />
        <SidePageV2.SubmitButton />
      </SidePageV2.Actions>
    </SidePageV2>
  );
});

export default MoveToAnotherAffiliateForm;
